import React from 'react';
import SupplierGHGView from '../modules/supplier-assessment/SupplierGHGView';

export default function SupplierAssessmentGHG() {
  return <SupplierGHGView />;
}
